var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.value)?_c('span',[_c('span',{staticClass:"signal signal-block"}),_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.label))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }